module.exports = __webpack_public_path__ + "static/media/eye-close.b3ff4308.svg";